import React from 'react';

export function TransfersSeveralItemsColumnFormatter(cellContent, showTitle = false, limitWidth = true) {

  const mappedCellContent = cellContent
    ? (cellContent.map(item => {
      return (
        <div title={showTitle ? item : ''} style={{ color: '#333', fontSize: '16px' }}
             className={`d-block text-nowrap ${limitWidth ? 'limited-content-width-column' : ''}`}
        >
          {item}
        </div>
      )
    }))
    : []

  return (
    <div>
      {mappedCellContent}
    </div>
  );
}
